//export const SERVER_URL = "https://revista.himalayac.com/revista/api/";
//export const SERVER_URL = "https://192.168.71.242/api/";
//export const SERVER_URL = "https://rescifar.farmaceuticosdesevilla.es/api/";

export const DEBUG = false;

export const SERVER_URL = DEBUG
  ? "http://localhost/revista-farmacia/api/"
  : "https://rescifar.farmaceuticosdesevilla.es/api/";

export async function post(op, body, responseType) {
  try {
    if (DEBUG) {
      console.log(SERVER_URL + op + ".php");
      console.log(body);
    }
    let data = null;
    const response = await fetch(SERVER_URL + op + ".php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (DEBUG) {
      console.log(response);
    }
    if (responseType === "json") {
      data = await response.json();
      if (DEBUG) {
        console.log(data);
      }
    }
    if (responseType === "text") {
      data = await response.text();
      if (data === " ") {
        data = "";
      }
      if (DEBUG) {
        console.log(data);
      }
    }
    return data;
  } catch (error) {
    if (DEBUG) {
      console.log(error);
    }
  }
}
